import { Injectable, signal } from '@angular/core';

export interface WizardShellComponentStep {
  index: number;
  title: string;
  label: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class WizardShellComponentService {
  readonly totalSteps = 3;
  readonly isActive = signal(false);
  readonly currentStep = signal<WizardShellComponentStep | null>(null);

  activate() {
    this.isActive.set(true);
  }

  deactivate() {
    this.isActive.set(false);
    this.currentStep.set(null);
  }

  setStep(step: WizardShellComponentStep) {
    this.currentStep.set(step);
  }
}
